module.exports = __webpack_public_path__ + "static/media/tzbtcLogo.2044573b.svg";